const WhatsappIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M380.9 97.1C339.3 55.5 283.5 32 224 32 100.3 32 0 132.3 0 256c0 45.2 11.7 89.1 33.8 127.8L2.5 480l100.9-30.9c36.6 20 78.1 30.9 120.6 30.9h.1c123.7 0 224-100.3 224-224 0-59.5-23.1-115.3-65.1-158.9zM224.1 438.7h-.1c-38.1 0-75.3-10.5-107.7-30.4l-7.7-4.6-60.2 18.4 19.5-58.2-5-8C42.7 318.5 32 287.6 32 256 32 150.1 118.1 64 224 64c50.6 0 98.2 19.7 134 55.4 35.8 35.8 55.4 83.4 55.4 134 0 105.9-86.1 192-189.9 192zm101.6-138.5c-5.6-2.8-33.2-16.4-38.3-18.3-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18.3-17.5 22-3.2 3.7-6.4 4.2-12 1.4-5.6-2.8-23.6-8.7-45-27.6-16.6-14.3-27.8-32-31-37.6-3.2-5.6-.3-8.6 2.5-11.4 2.6-2.6 5.6-6.4 8.4-9.6 2.8-3.2 3.7-5.6 5.6-9.3 1.9-3.7.9-7-0.5-9.8-1.4-2.8-12.5-30.2-17.1-41.3-4.5-11-9.1-9.3-12.5-9.5-3.2-.2-7-.2-10.7-.2s-9.8 1.4-15 7c-5.1 5.6-19.7 19.3-19.7 47.1s20.2 54.6 23 58.4c2.8 3.7 39.5 60.3 95.7 84.6 13.4 5.8 23.8 9.3 31.9 11.9 13.4 4.2 25.6 3.6 35.3 2.2 10.8-1.6 33.2-13.5 37.8-26.6 4.7-13.1 4.7-24.3 3.2-26.6-1.6-2.3-5.1-3.7-10.7-6.4z" />
  </svg>
);

export default WhatsappIcon;
